// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: au2Ok7jK5Y

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import HeaderMenu from "../../HeaderMenu"; // plasmic-import: JEN29JpsqO/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicAppHeader.module.css"; // plasmic-import: au2Ok7jK5Y/css

import HhLogoSmallsvgIcon from "./icons/PlasmicIcon__HhLogoSmallsvg"; // plasmic-import: m0fZav8zv/icon
import IconarrowIosLeft8Icon from "./icons/PlasmicIcon__IconarrowIosLeft8"; // plasmic-import: vQT5Z4YJnWT/icon

createPlasmicElementProxy;

export type PlasmicAppHeader__VariantMembers = {
  view:
    | "seeAllView"
    | "sectionView"
    | "videoView"
    | "readerView"
    | "welcomeView";
  editMode: "editMode";
};
export type PlasmicAppHeader__VariantsArgs = {
  view?: SingleChoiceArg<
    "seeAllView" | "sectionView" | "videoView" | "readerView" | "welcomeView"
  >;
  editMode?: SingleBooleanChoiceArg<"editMode">;
};
type VariantPropType = keyof PlasmicAppHeader__VariantsArgs;
export const PlasmicAppHeader__VariantProps = new Array<VariantPropType>(
  "view",
  "editMode"
);

export type PlasmicAppHeader__ArgsType = {};
type ArgPropType = keyof PlasmicAppHeader__ArgsType;
export const PlasmicAppHeader__ArgProps = new Array<ArgPropType>();

export type PlasmicAppHeader__OverridesType = {
  root?: p.Flex<"div">;
  leftContainer?: p.Flex<"button">;
  svg?: p.Flex<"svg">;
  headerMenu?: p.Flex<typeof HeaderMenu>;
};

export interface DefaultAppHeaderProps {
  view?: SingleChoiceArg<
    "seeAllView" | "sectionView" | "videoView" | "readerView" | "welcomeView"
  >;
  editMode?: SingleBooleanChoiceArg<"editMode">;
  className?: string;
}

const $$ = {};

function PlasmicAppHeader__RenderFunc(props: {
  variants: PlasmicAppHeader__VariantsArgs;
  args: PlasmicAppHeader__ArgsType;
  overrides: PlasmicAppHeader__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "view",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.view
      },
      {
        path: "editMode",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.editMode
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootview_readerView]: hasVariant($state, "view", "readerView"),
          [sty.rootview_seeAllView]: hasVariant($state, "view", "seeAllView"),
          [sty.rootview_videoView]: hasVariant($state, "view", "videoView"),
          [sty.rootview_welcomeView]: hasVariant($state, "view", "welcomeView")
        }
      )}
    >
      <button
        data-plasmic-name={"leftContainer"}
        data-plasmic-override={overrides.leftContainer}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.leftContainer
        )}
        ref={ref => {
          $refs["leftContainer"] = ref;
        }}
      >
        <p.PlasmicIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          PlasmicIconType={
            hasVariant($state, "view", "readerView")
              ? IconarrowIosLeft8Icon
              : hasVariant($state, "view", "videoView")
              ? IconarrowIosLeft8Icon
              : hasVariant($state, "view", "seeAllView")
              ? IconarrowIosLeft8Icon
              : HhLogoSmallsvgIcon
          }
          className={classNames(projectcss.all, sty.svg, {
            [sty.svgglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.svgview_readerView]: hasVariant($state, "view", "readerView"),
            [sty.svgview_seeAllView]: hasVariant($state, "view", "seeAllView"),
            [sty.svgview_videoView]: hasVariant($state, "view", "videoView")
          })}
          role={"img"}
        />
      </button>
      {(
        hasVariant($state, "view", "readerView")
          ? true
          : hasVariant($state, "view", "videoView")
          ? false
          : true
      ) ? (
        <HeaderMenu
          data-plasmic-name={"headerMenu"}
          data-plasmic-override={overrides.headerMenu}
          className={classNames("__wab_instance", sty.headerMenu, {
            [sty.headerMenueditMode]: hasVariant(
              $state,
              "editMode",
              "editMode"
            ),
            [sty.headerMenuglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.headerMenuview_readerView]: hasVariant(
              $state,
              "view",
              "readerView"
            ),
            [sty.headerMenuview_sectionView]: hasVariant(
              $state,
              "view",
              "sectionView"
            ),
            [sty.headerMenuview_seeAllView]: hasVariant(
              $state,
              "view",
              "seeAllView"
            ),
            [sty.headerMenuview_videoView]: hasVariant(
              $state,
              "view",
              "videoView"
            ),
            [sty.headerMenuview_welcomeView]: hasVariant(
              $state,
              "view",
              "welcomeView"
            )
          })}
          hideSignUpButton={true}
          view={
            hasVariant($state, "view", "welcomeView")
              ? "welcomeView"
              : hasVariant($state, "view", "readerView")
              ? "seeAllView"
              : hasVariant($state, "view", "videoView")
              ? "seeAllView"
              : hasVariant($state, "view", "seeAllView")
              ? "seeAllView"
              : "sectionView"
          }
        />
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "leftContainer", "svg", "headerMenu"],
  leftContainer: ["leftContainer", "svg"],
  svg: ["svg"],
  headerMenu: ["headerMenu"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  leftContainer: "button";
  svg: "svg";
  headerMenu: typeof HeaderMenu;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAppHeader__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAppHeader__VariantsArgs;
    args?: PlasmicAppHeader__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicAppHeader__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicAppHeader__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAppHeader__ArgProps,
          internalVariantPropNames: PlasmicAppHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAppHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAppHeader";
  } else {
    func.displayName = `PlasmicAppHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicAppHeader = Object.assign(
  // Top-level PlasmicAppHeader renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    leftContainer: makeNodeComponent("leftContainer"),
    svg: makeNodeComponent("svg"),
    headerMenu: makeNodeComponent("headerMenu"),

    // Metadata about props expected for PlasmicAppHeader
    internalVariantProps: PlasmicAppHeader__VariantProps,
    internalArgProps: PlasmicAppHeader__ArgProps
  }
);

export default PlasmicAppHeader;
/* prettier-ignore-end */
